import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { money } from "@/lib/format";
import { Loader2, DollarSign, ShoppingBag, TrendingUp, Award, Cookie, Ruler, Sparkles, Users, Store, Truck, Building2 } from "lucide-react";

export default function Analytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)); }, []);

  if (!a) return <AdminLayout><div className="flex justify-center py-20"><Loader2 className="animate-spin text-gold" size={36} /></div></AdminLayout>;

  const stats = [
    { icon: DollarSign, label: "Total Sales (confirmed)", value: money(a.total_sales) },
    { icon: ShoppingBag, label: "Total Orders", value: a.total_orders },
    { icon: TrendingUp, label: "Avg Order Value", value: money(a.average_order_value) },
    { icon: Award, label: "Best Popcorn", value: a.best_selling_popcorn || "—" },
    { icon: Cookie, label: "Best Cookie", value: a.best_selling_cookie || "—" },
    { icon: Ruler, label: "Best Size", value: a.best_selling_size || "—" },
    { icon: Sparkles, label: "Cinnamon Pecan Sales", value: money(a.cinnamon_pecan_sales) },
    { icon: Building2, label: "CarMax Orders", value: a.carmax_orders },
    { icon: Users, label: "Repeat Customers", value: a.repeat_customers },
  ];

  return (
    <AdminLayout>
      <h1 className="font-serif text-3xl text-cream mb-6">Analytics</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {stats.map((s) => (
          <div key={s.label} className="gold-border-card rounded-xl bg-card-surface p-5" data-testid={`analytics-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <s.icon className="text-gold mb-2" size={22} />
            <p className="font-mono text-cream text-2xl font-bold truncate">{s.value}</p>
            <p className="text-cream/50 text-xs mt-1">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        {[["pickup", "Pickup", Store], ["local_delivery", "Delivery", Truck], ["carmax_delivery", "CarMax", Building2]].map(([k, l, Icon]) => (
          <div key={k} className="gold-border-card rounded-xl bg-card-surface p-5 flex items-center gap-4">
            <Icon className="text-gold" size={26} />
            <div><p className="font-mono text-cream text-2xl font-bold">{a.fulfillment?.[k] || 0}</p><p className="text-cream/50 text-xs">{l} orders</p></div>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="gold-border-card rounded-xl bg-card-surface p-5">
          <h3 className="font-serif text-gold mb-3">Popcorn Sales Breakdown</h3>
          {Object.entries(a.popcorn_breakdown || {}).sort((x, y) => y[1] - x[1]).map(([n, c]) => (
            <div key={n} className="flex justify-between text-sm text-cream/80 py-1"><span>{n}</span><span className="font-mono">{c}</span></div>
          ))}
          {Object.keys(a.popcorn_breakdown || {}).length === 0 && <p className="text-cream/40 text-sm">No sales yet.</p>}
        </div>
        <div className="gold-border-card rounded-xl bg-card-surface p-5">
          <h3 className="font-serif text-gold mb-3">Cookie Sales Breakdown</h3>
          {Object.entries(a.cookie_breakdown || {}).sort((x, y) => y[1] - x[1]).map(([n, c]) => (
            <div key={n} className="flex justify-between text-sm text-cream/80 py-1"><span>{n}</span><span className="font-mono">{c}</span></div>
          ))}
          {Object.keys(a.cookie_breakdown || {}).length === 0 && <p className="text-cream/40 text-sm">No sales yet.</p>}
        </div>
      </div>
    </AdminLayout>
  );
}
